import { render, staticRenderFns } from "./WarehouseManagerView.vue?vue&type=template&id=24924cc8&scoped=true"
import script from "./WarehouseManagerView.vue?vue&type=script&lang=js"
export * from "./WarehouseManagerView.vue?vue&type=script&lang=js"
import style0 from "./WarehouseManagerView.vue?vue&type=style&index=0&id=24924cc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24924cc8",
  null
  
)

export default component.exports